module.exports = __webpack_public_path__ + "static/img/star_person_service.f81f5190.png";